import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ShopNav from '../../../components/shopNav/ShopNav';
import Footer from '../../../components/footer/footer';
import NavCategorias from '../../../components/navbar/NavCategorias';
import { useDispatch, useSelector } from 'react-redux';  // Para usar el estado global
import { clearPreviousRoute } from '../../../store/navigationSlice';
import { loginSuccess } from '../../../store/authSlice';
import ReCAPTCHA from 'react-google-recaptcha';
import './RegisterForm.css';

const API_URL = import.meta.env.VITE_API_URL;


const RegisterForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const previousRoute = useSelector(state => state.navigation.previousRoute); // ✔️ Trae el valor correcto

  const [recaptchaToken, setRecaptchaToken] = useState('');



  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = 'El nombre es obligatorio.';
    }

    if (!formData.email) {
      newErrors.email = 'El correo es obligatorio.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'El correo no es válido.';
    }

    if (!formData.password) {
      newErrors.password = 'La contraseña es obligatoria.';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Debe tener al menos 6 caracteres.';
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Confirma tu contraseña.';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
  
    if (!validate()) return;
  
    if (!recaptchaToken) {
      setServerError('Por favor completa el reCAPTCHA.');
      return;
    }
  
    try {
      const response = await axios.post(`${API_URL}/authStore/signup`, {
        ...formData,
        recaptchaToken, // ⬅️ Lo enviamos al backend
      });
  
      const { token, user } = response.data;
      dispatch(loginSuccess({ token, user }));
  
      if (previousRoute && previousRoute.pathname !== '/loginVpStore') {
        navigate(previousRoute.pathname);
        dispatch(clearPreviousRoute());
      } else {
        navigate('/mi-cuenta');
      }
    } catch (error) {
      console.error('❌ Error en el registro', error);
      setServerError('Hubo un problema al registrar. Intenta nuevamente.');
    }
  };
  


  return (
    <div className="register-page">
      <ShopNav />
      <NavCategorias />

      <main className="register-page-main">
        <section className="register-page-hero register-page-elevated-wrap register-page-elevated-wrap--hero">
          <div className="container register-page-hero-inner">
            <div className="register-page-hero-copy">
              <h1 className="display-5">Crea tu cuenta</h1>
              <p className="lead">
                Regístrate para guardar tu carrito, gestionar tus pedidos y acceder más rápido a tu compra.
              </p>
            </div>
            <div className="register-page-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="register-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="container register-content-wrap">
          <div className="register-form-shell">
            <div className="register-form-head text-center">
              <h2 className="register-form-title">Crear Cuenta</h2>
              <p className="register-form-subtitle">Completa tus datos para empezar.</p>
            </div>

            <form onSubmit={handleSubmit} noValidate className="register-form-body">
            {/* Nombre */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label register-form-label">Nombre</label>
              <input
                type="text"
                className={`form-control register-input ${errors.name ? 'is-invalid' : formData.name && 'is-valid'}`}
                id="name"
                name="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            {/* Correo */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label register-form-label">Correo electrónico</label>
              <input
                type="email"
                className={`form-control register-input ${errors.email ? 'is-invalid' : formData.email && 'is-valid'}`}
                id="email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            {/* Contraseña */}
            <div className="mb-3">
              <label htmlFor="password" className="form-label register-form-label">Contraseña</label>
              <div className="input-group register-input-group">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className={`form-control register-input ${errors.password ? 'is-invalid' : formData.password && 'is-valid'}`}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
                <button
                  type="button"
                  className="btn register-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
              {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
            </div>

            {/* Confirmar contraseña */}
            <div className="mb-3">
              <label htmlFor="confirmPassword" className="form-label register-form-label">Confirmar contraseña</label>
              <input
                type={showPassword ? 'text' : 'password'}
                className={`form-control register-input ${errors.confirmPassword ? 'is-invalid' : formData.confirmPassword && 'is-valid'}`}
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              />
              {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
            </div>

            {/* Mensaje de error servidor */}
            {serverError && (
              <div className="alert alert-danger register-server-error" role="alert">
                {serverError}
              </div>
            )}

            <div className="register-recaptcha-wrap mb-3 d-flex justify-content-center">
              <ReCAPTCHA
                sitekey="6LcHco8rAAAAALYNxuX2ypmiOPyohdfU2CHJurL6"
                onChange={(token) => setRecaptchaToken(token)}
                className="mb-3"
              />
            </div>

            {/* Botón de registro */}
            <button type="submit" className="btn w-100 register-submit-btn">Registrarse</button>

            {/* Línea divisoria */}
            <div className="text-center mt-3 register-divider-wrap">
              <span className="register-divider-text">o continúa con</span>
            </div>

            {/* Login social */}
            <div className="d-flex justify-content-center gap-3 mt-3">
              <button type="button" className="btn w-50 register-social-btn register-social-btn-google">
                <i className="bi bi-google me-2"></i>Google
              </button>
              <button type="button" className="btn w-50 register-social-btn register-social-btn-facebook">
                <i className="bi bi-facebook me-2"></i>Facebook
              </button>
            </div>
          </form>
        </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default RegisterForm;
